import { defineMessages } from 'react-intl';

import { Schema as sectionSubtitleSchema } from './schema';
import SectionSubtitleEdit from './SectionSubtitleEdit';
import SectionSubtitleView from './SectionSubtitleView';

import sectionSubtitleSVG from './icons/section-subtitle.svg';

defineMessages({
  Header: {
    id: 'Section Subtitle',
    defaultMessage: 'Section Subtitle',
  },
});

const applyConfig = (config) => {
  config.blocks.blocksConfig.SectionSubtitleBlock = {
    id: 'SectionSubtitleBlock',
    title: 'Section Subtitle',
    group: 'text',
    icon: sectionSubtitleSVG,
    view: SectionSubtitleView,
    edit: SectionSubtitleEdit,
    blockSchema: sectionSubtitleSchema,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
  };
  return config;
};

export default applyConfig;
